import { useMemo } from "react";
import { useHistory, useLocation } from "react-router-dom";
import { QueryParams } from "../types";
import { paramsToSearchString, searchStringToParams } from "../utils/urlHelper";
import { SearchBackingState } from "./useSearch";

export const useUrl = (): SearchBackingState => {
  const { search, pathname } = useLocation();
  const { push } = useHistory();

  const searchParams = useMemo(() => searchStringToParams(search), [search]);

  const navigate = (params: QueryParams) => {
    const nextQuery = paramsToSearchString({
      ...params,
    });
    push(`${pathname}${nextQuery}`);
  };

  return {
    navigate,
    searchParams,
  };
};
